var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"about"},[_c('div',{staticClass:"about_logo"},[_c('img',{staticStyle:{"width":"100px","height":"100px","border-radius":"100px"},attrs:{"src":require("../../assets/yun_icu_logo.png"),"alt":""}}),_c('h3',{staticStyle:{"color":"#5EA5E0"}},[_vm._v("让学习、诊疗更便捷！")]),_c('h4',{staticStyle:{"color":"#909399"}},[_vm._v("版本5.4.2")])])])
}]

export { render, staticRenderFns }